import { Map as map } from 'immutable';
const C = require("../constants");

function AlertReducer(state = map(), action) {
    switch (action.type) {
        case C.SHOW_ALERT:
            return action.data;
        default:
            return state;
    }
};

export default AlertReducer;


// WEBPACK FOOTER //
// ./src/reducers/AlertReducer.js